import React, { Component } from "react";
import Translator from "../../../requests/apa/Translator";
import Button from "../../Button";
import EpgFeederManager from "../../../AAFPersistenceManager/feeders/EpgFeederManager";

class ContentUpdateEpg extends Component {


  constructor(props) {
    super(props);
  }

  render() {
    return(
      <div id="" className="ContentLanguage">
        <p>{ this.props.text }</p>
        <small>{this.props.notApply}</small>
        <div className="frameLanguage">
          <div className="content">
            <Button text={Translator.get('','Actualizar')} onClick={()=>{
              new EpgFeederManager().inserting();
            }}/>
          </div>
        </div>
      </div>
    )
  }
}

export default ContentUpdateEpg;



// WEBPACK FOOTER //
// ./src/components/User-Settings/ContentUpdateEpg/index.jsx